import { render, staticRenderFns } from "./SaleInfoAwsDocuments.vue?vue&type=template&id=b3112f7a&scoped=true"
import script from "./SaleInfoAwsDocuments.vue?vue&type=script&lang=ts"
export * from "./SaleInfoAwsDocuments.vue?vue&type=script&lang=ts"
import style0 from "./SaleInfoAwsDocuments.vue?vue&type=style&index=0&id=b3112f7a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3112f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3112f7a')) {
      api.createRecord('b3112f7a', component.options)
    } else {
      api.reload('b3112f7a', component.options)
    }
    module.hot.accept("./SaleInfoAwsDocuments.vue?vue&type=template&id=b3112f7a&scoped=true", function () {
      api.rerender('b3112f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleInfoAwsDocuments.vue"
export default component.exports